import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const Careers = () => {
  return <SingleContentPage title="Careers" moduleKey="careers" />;
};

export default Careers;
